import { ITranslations } from 'types/common';
import { ConfirmPopupTransFields } from './types';
import en from 'translations/en/confirmPopup.json';
import pl from 'translations/pl/confirmPopup.json';
import sl from 'translations/sl/confirmPopup.json';

export const confirmPopupTranslations: ITranslations<ConfirmPopupTransFields> = {
  name: 'confirmPopup',
  en,
  pl,
  sl,
};
